import React from 'react';
import { uid } from 'react-uid';
import PropTypes from 'prop-types';
import Skeleton from './Skeleton';
import StyledGalleryImage from './GalleryImage.styled';
function GalleryImageSkeleton(_ref) {
  var amount = _ref.amount;
  return Array(amount).fill(1).map(function (_, i) {
    return /*#__PURE__*/React.createElement(StyledGalleryImage, {
      key: uid("gallery-loading-image-" + i)
    }, /*#__PURE__*/React.createElement(Skeleton, {
      width: "100%",
      height: "100%",
      variant: "rectangular"
    }));
  });
}
GalleryImageSkeleton.propTypes = process.env.NODE_ENV !== "production" ? {
  amount: PropTypes.number
} : {};
GalleryImageSkeleton.defaultProps = {
  amount: 1
};
export default GalleryImageSkeleton;